module.exports = __webpack_public_path__ + "img/about6.935f030.jpg";